/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetInspectedProductDto,
    GetInspectedProductDtoFromJSON,
    GetInspectedProductDtoFromJSONTyped,
    GetInspectedProductDtoToJSON,
    GetOrganizationalUnitDto,
    GetOrganizationalUnitDtoFromJSON,
    GetOrganizationalUnitDtoFromJSONTyped,
    GetOrganizationalUnitDtoToJSON,
    GetProductTypeDto,
    GetProductTypeDtoFromJSON,
    GetProductTypeDtoFromJSONTyped,
    GetProductTypeDtoToJSON,
    GetSampleDto,
    GetSampleDtoFromJSON,
    GetSampleDtoFromJSONTyped,
    GetSampleDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetPakWithPartiesDto
 */
export interface GetPakWithPartiesDto {
    /**
     * 
     * @type {string}
     * @memberof GetPakWithPartiesDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof GetPakWithPartiesDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetPakWithPartiesDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetPakWithPartiesDto
     */
    penaltyAmount: string;
    /**
     * 
     * @type {string}
     * @memberof GetPakWithPartiesDto
     */
    quantity: string;
    /**
     * 
     * @type {string}
     * @memberof GetPakWithPartiesDto
     */
    paidAmount: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPakWithPartiesDto
     */
    approved: boolean;
    /**
     * 
     * @type {GetOrganizationalUnitDto}
     * @memberof GetPakWithPartiesDto
     */
    organizationalUnit: GetOrganizationalUnitDto;
    /**
     * 
     * @type {string}
     * @memberof GetPakWithPartiesDto
     */
    proceedingId: string;
    /**
     * 
     * @type {GetSampleDto}
     * @memberof GetPakWithPartiesDto
     */
    sample: GetSampleDto;
    /**
     * 
     * @type {GetInspectedProductDto}
     * @memberof GetPakWithPartiesDto
     */
    inspectedProduct: GetInspectedProductDto;
    /**
     * 
     * @type {GetProductTypeDto}
     * @memberof GetPakWithPartiesDto
     */
    productType: GetProductTypeDto;
    /**
     * 
     * @type {string}
     * @memberof GetPakWithPartiesDto
     */
    actNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetPakWithPartiesDto
     */
    parties: string;
}

export function GetPakWithPartiesDtoFromJSON(json: any): GetPakWithPartiesDto {
    return GetPakWithPartiesDtoFromJSONTyped(json, false);
}

export function GetPakWithPartiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPakWithPartiesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'startDate': !exists(json, 'startDate') ? undefined : (json['startDate'] === null ? null : new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (json['endDate'] === null ? null : new Date(json['endDate'])),
        'penaltyAmount': json['penaltyAmount'],
        'quantity': json['quantity'],
        'paidAmount': json['paidAmount'],
        'approved': json['approved'],
        'organizationalUnit': GetOrganizationalUnitDtoFromJSON(json['organizationalUnit']),
        'proceedingId': json['proceedingId'],
        'sample': GetSampleDtoFromJSON(json['sample']),
        'inspectedProduct': GetInspectedProductDtoFromJSON(json['inspectedProduct']),
        'productType': GetProductTypeDtoFromJSON(json['productType']),
        'actNumber': json['actNumber'],
        'parties': json['parties'],
    };
}

export function GetPakWithPartiesDtoToJSON(value?: GetPakWithPartiesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'startDate': value.startDate === undefined ? undefined : (value.startDate === null ? null : value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate === null ? null : value.endDate.toISOString()),
        'penaltyAmount': value.penaltyAmount,
        'quantity': value.quantity,
        'paidAmount': value.paidAmount,
        'approved': value.approved,
        'organizationalUnit': GetOrganizationalUnitDtoToJSON(value.organizationalUnit),
        'proceedingId': value.proceedingId,
        'sample': GetSampleDtoToJSON(value.sample),
        'inspectedProduct': GetInspectedProductDtoToJSON(value.inspectedProduct),
        'productType': GetProductTypeDtoToJSON(value.productType),
        'actNumber': value.actNumber,
        'parties': value.parties,
    };
}


